<div class="row">
  <div class="column">
    <h3>Contact Info</h3>
    <form [formGroup]="contactInfoForm">
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName">
          <mat-error *ngIf="contactInfoForm.get('firstName')?.hasError('required')">
            First name is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="column">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName">
          <mat-error *ngIf="contactInfoForm.get('lastName')?.hasError('required')">
            Last name is required.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Email Address</mat-label>
          <input matInput formControlName="email">
          <mat-error *ngIf="contactInfoForm.get('email')?.hasError('required')">
            Email name is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="column">
          <mat-label>Phone Number</mat-label>
          <input matInput formControlName="phone">
          <mat-error *ngIf="contactInfoForm.get('phone')?.hasError('required')">
            Phone number is required.
          </mat-error>
          <mat-error *ngIf="contactInfoForm.get('phone')?.hasError('pattern')">
            Please use a valid phone number.
          </mat-error>
        </mat-form-field>
      </div>
    </form>
    <app-address-info-card [hideNotes]="true" [addressInfo]="account"></app-address-info-card>
    <div class="row">
      <mat-form-field appearance="outline" class="column">
        <mat-label>eSignature</mat-label>
        <input matInput [value]="account.printedName" disabled>
      </mat-form-field>
    </div>
  </div>
  <mat-divider [vertical]="true"></mat-divider>
  <div class="column">
    <form [formGroup]="otherInfoForm">
      <h3>Other Info</h3>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status" placeholder="Status">
            <mat-select-trigger>
              <app-status-indicator [isDropdownOption]="true"
                [statusText]="this.otherInfoForm.value.status"></app-status-indicator>
            </mat-select-trigger>
            <mat-option value="ACTIVE"><app-status-indicator [isDropdownOption]="true"
                statusText="Active"></app-status-indicator></mat-option>
            <mat-option value="CLOSED"><app-status-indicator [isDropdownOption]="true"
                statusText="Closed"></app-status-indicator></mat-option>
            <mat-option value="INACTIVE"><app-status-indicator [isDropdownOption]="true"
                statusText="Inactive"></app-status-indicator></mat-option>
          </mat-select>
          <mat-error *ngIf="otherInfoForm.get('status')?.hasError('required')">
            Status is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="column">
          <mat-label>Filing preference</mat-label>
          <mat-select formControlName="billingFreq" placeholder="Filing preference">
            <mat-option [value]="'M'">Monthly</mat-option>
            <mat-option [value]="'Q'">Quarterly</mat-option>
          </mat-select>
          <mat-error *ngIf="otherInfoForm.get('billingFreq')?.hasError('required')">
            Filing preference is required.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Credit</mat-label>
          <input matInput type="float" formControlName="credit" appCurrencyInput="USD">
          <mat-error *ngIf="otherInfoForm.get('credit')?.hasError('required')">
            Credit is required.
          </mat-error>
          <mat-error *ngIf="otherInfoForm.get('credit')?.hasError('pattern')">
            Please insert just numbers.
          </mat-error>
        </mat-form-field>
        <div class="column spacer"></div>
      </div>
    </form>
  </div>
</div>
